import React, { useState } from 'react';
import PasswordModal from './password_modal';

export default function MFASettings(props) {
  const [enabled, setEnabled] = useState(props.initialStatus);
  const [open, setOpen] = useState(false);

  const handleMfaToggle = () => {
    setOpen(true);
  };

  function ensureModalIsClosed() {
    setOpen(false);
  }

  const handleMfaStatusChange = (newStatus) => {
    setEnabled(newStatus);
  };

  return (
    <div className="mfa-settings">
      <div className="row">
        <div className="col-xs-9 left-align">
          <h3 className="section-header-name">MFA (Multi-factor Authentication)</h3>
          <p>MFA is a common login requirement for an extra layer of security. Use the directions listed to complete the MFA process.</p>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-2 col-sm-1">
          <button
            onClick={handleMfaToggle}
            className={`btn mfa-button ${enabled ? "mfa-disable" : "mfa-enable"}`}
          >
            {enabled ? 'disable' : 'enable'} mfa security
          </button>
        </div>
      </div>
      <PasswordModal
        {...props}
        open={open}
        onClose={ensureModalIsClosed}
        currentStatus={enabled}
        onStatusChange={handleMfaStatusChange}
      />
    </div>
  );
}
